export type MqttWorkerClientOptions = {
  iss?: string;
  userId?: string;
  roles?: string[];
};

export function generateClientId(clientName: string, clientOptions?: MqttWorkerClientOptions) {
  const object: MqttWorkerClientOptions = {
    iss: 'guest',
    userId: 'guest',
    roles: ['guest'],
    ...clientOptions,
  };
  const clientID = `${clientName}_${object?.iss || 'unknown'}_${object?.roles?.[0] || 'unknown'}_${
    object?.userId || 'unknown'
  }_${getRandomString(5)}`;
  return clientID;
}

export function getRandomString(minLength = 0, acc = ''): string {
  if (acc.length <= minLength) {
    const str = Math.random().toString(36).slice(2);
    // eslint-disable-next-line unicorn/prefer-spread
    return getRandomString(minLength, acc.concat(str));
  }

  return acc.slice(0, minLength);
}

export const timestampToDate = (
  timestamp: { nanos: number | null; seconds: number | null } = { nanos: 0, seconds: 0 },
): Date | null => {
  const { nanos, seconds } = timestamp;
  if (typeof nanos !== 'number' || typeof seconds !== 'number') {
    return null;
  }
  return new Date(seconds * 1000 + nanos / 1_000_000);
};
